/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { login, logoff,loadUserFromStorage } from "_services/oauth";
import axios from "axios";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Hidden from '@material-ui/core/Hidden';
import Datetime from 'react-datetime';
import Select from 'react-select';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Fab from '@material-ui/core/Fab';


import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
//import TSLeaveForm from "components/Forms/TSLeaveForm"; 
import PdfFile from "views/Report/PdfFile";
import TSRadio from "components/Forms/TSRadio";
import TSCheckBox from "components/Forms/TSCheckBox";

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import HotelIcon from '@material-ui/icons/Hotel';
import RepeatIcon from '@material-ui/icons/Repeat';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";


import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import Leave from "layouts/Leave";
import { ContactsRounded, Description, Grade } from "@material-ui/icons";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: "gray",
  },
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  largeAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  biggerAvatar: {
    width: theme.spacing(20),
    height: theme.spacing(20),
  },
}));
//const useStyles = makeStyles(styles);

const Request = (props) => {

  var currentUser = JSON.parse(localStorage.getItem('currentUser'));

  const { location, ...other } = props;
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  //const _leaveRequestID = (location.state != null && (location.state.leaveRequestID != null && location.state.leaveRequestID != '')) ? location.state.leaveRequestID: null;
  const _serviceRequestID = (location.state != null && (location.state.ServiceRequestID != null && location.state.ServiceRequestID != '')) ? location.state.ServiceRequestID: null;



  var moment = require('moment');
  require('moment/locale/th');
  const [ServiceRequestID, setServiceRequestID] = useState('');


  const [additionalInfo, setAdditionalInfo] = useState('');   
  const [otherDetails, setOtherDetails] = useState('');
  const [researchTitle, setResearchTitle] = useState('');
  const [researchObjective, setResearchObjective] = useState('');
  const [researchMethodology, setResearchMethodology] = useState('');
  const [populationAndSample, setPopulationAndSample] = useState('');
  const [otherInfo, setOtherInfo] = useState('');
  

  const [ContactAddress, setContactAddress] = useState('');
  const [ContactPhone, setContactPhone] = useState('');
  const [UserName, setUserName] = useState('');

  const [holidays, setHolidays] = useState([]);

  const [isHovered, setIsHovered] = useState(false);
  const [isApprove, setIsApprove] = useState(true);
  const [isReceiveMoney, setIsReceiveMoney] = useState(true);
  const [ArrLeaveType, setArrLeaveType] = useState([]);
  const [ArrStandin, setArrStandin] = useState([]);
  const [ArrDepartmentBoss, setArrDepartmentBoss] = useState([]);
  const [ArrGroupworkBoss, setArrGroupworkBoss] = useState([]);
  const [ArrMissionBoss, setArrMissionBoss] = useState([]);
  const [ArrDirector, setArrDirector] = useState([]);
  const [LeaveApprove, setLeaveApprove] = useState([]);
  const [ApproveDirector, setApproveDirector] = useState(false);


  const [Standin, SetStandin] = useState("");
  const [DepartmentBoss, SetDepartmentBoss] = useState("");
  const [GroupworkBoss, SetGroupworkBoss] = useState("");
  const [MissionBoss, SetMissionBoss] = useState("");

   const [Director, SetDirector] = useState("");
   const [ServiceApproveKey, setServiceApproveKey] = useState(0);
   const [ApproveTypeKey, setApproveTypeKey] = useState(0);
   const [ApproveDescription, setApproveDescription] = useState('เห็นควรอนุญาต');


  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");
  const [FullName, setFullName] = useState('');
  const [PositionName, setPositionName] = useState('');
  const [TypeGovName, setTypeGovName] = useState('');
  const [GroupText, SetGroupText] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [isHR, setIsHR] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [dateFocus, setDateFocus] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // เก็บข้อมูลไฟล์ที่เลือก

  const [researchServiceList, setResearchServiceList] = useState([]);
  const [researchService, setResearchService] = useState(null);
  const [tempServiceKey, setTempServiceKey] = useState(null);
  const [ServiceApprove, setServiceApprove] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]); 
  const [existingFiles, setExistingFiles] = useState([]);
  
  

  const myRef = useRef(null);
  const fileInputRef = useRef(null); 
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    // ตรวจสอบขนาดไฟล์ทีละไฟล์ (ห้ามเกิน 10MB)
    const validFiles = files.filter(file => {
        if (file.size > 10 * 1024 * 1024) {
            alert(`ไฟล์ "${file.name}" มีขนาดใหญ่เกิน 10 MB`);
            return false;
        }
        return true;
    });

    // นำไฟล์ใหม่ไปต่อท้ายอาเรย์ของไฟล์เดิมที่ผู้ใช้เคยเลือกไว้
    setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
    
    // ล้างค่าใน input เพื่อให้สามารถกดเลือกไฟล์เดิมซ้ำได้หากต้องการ
    if (fileInputRef.current) fileInputRef.current.value = ""; 
  };

  const removeFile = (indexToRemove) => {
    // ลบไฟล์ออกจากอาเรย์ตาม index ที่กดลบ
    setSelectedFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
  };

  const [approveFiles, setApproveFiles] = useState([]);
  const approveFileInputRef = useRef(null);

  const handleApproveFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => {
        if (file.size > 10 * 1024 * 1024) {
            alert(`ไฟล์ "${file.name}" มีขนาดใหญ่เกิน 10 MB`);
            return false;
        }
        return true;
    });
    setApproveFiles(prevFiles => [...prevFiles, ...validFiles]);
    if (approveFileInputRef.current) approveFileInputRef.current.value = "";
  };

  const removeApproveFile = (indexToRemove) => {
    setApproveFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
  };

  const isEdit = (location.state != null && (location.state.ServiceRequestID  != null && location.state.ServiceRequestID  != ''));

  useEffect(() => {

    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    
    const _isHR = currentUser.userDepartment.filter(u => u.departmentKey == 108).length > 0;
    setIsHR(_isHR);

    var _alt = [];
    axios.post("/api/v1/leave/type", {"IsApprove": true, "LeaveRequestID": (isEdit ? location.state.leaveRequestID : '00000000-0000-0000-0000-000000000000')})
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"name":').join('"label":').split('"leaveTypeKey":').join('"value":')*/);
            setArrLeaveType(json)
            _alt = json;
        }, error => { console.log(error); }
    );  

    axios.post("/api/v1/myteam", {leaveRequestID: isEdit ? location.state.leaveRequestID: '00000000-0000-0000-0000-000000000000' })
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);
            
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName.toLowerCase(),
              label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
            }));
            


            const jsonMy = myteam.filter(e => e.userName.toLowerCase() == result.data.userName.toLowerCase() && e.isDefault)[0];
         
            if(!isEdit){
              setContactPhone(jsonMy.userProfile.mobilePhone);
              setContactAddress(jsonMy.userProfile.address);
            }

            const jsonStanin = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey < 3)
            setArrStandin(jsonStanin)

            const jsonDept = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey == 1 && jsonMy.userLevelKey < 1 /*e.userLevelKey == jsonMy.userLevelKey*/)
            setArrDepartmentBoss(jsonDept)

            const jsonGroup = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 && e.isDefault) && jsonMy.userLevelKey < 2)
            setArrGroupworkBoss(jsonGroup)

            const jsonMission = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 || e.userLevelKey == 3) && jsonMy.userLevelKey < 3)
            setArrMissionBoss(jsonMission)

        }, error => { console.log(error); }
      );  


      axios.post("/api/v1/director", { userName: "" })
          .then(
              result => {
                  var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);

                  const myteam = json.map((o) => ({
                      ...o,
                      value: o.userName,
                      label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
                  }));

                  const jsonDirector = myteam.filter(e => e.userName != result.data.userName)
                  setArrDirector(jsonDirector)


              }, error => { console.log(error); }
          );  

    fetchHoliday(moment().format('YYYY/M'));

        if(isEdit)
        {
          axios({
            method: 'get',
              url: "/api/v1/service-request/" + location.state.ServiceRequestID,
              headers: { 'referpage': '/service-request/request/'+ location.state.ServiceRequestID }
          })
          .then(
              resEdit => {
                var res= resEdit.data.data;
                setOtherDetails(res.requestDetail)
                setResearchTitle(res.projectTitle)
                setResearchObjective(res.researchObjective)
                setPopulationAndSample(res.populationSample)
                setOtherInfo(res.additionalNote)
                setAdditionalInfo(res.otherServiceText)
                setResearchMethodology(res.researchDesign)

                setTempServiceKey(res.researchServiceKey);
                setIsCancel(res.isCancel)

                setServiceApprove(res.serviceApprove);
                setExistingFiles(resEdit.data.files || []);
              },
              error => {
                console.log(error);
              }
          ); 
        }   
    

        const fetchData = async () => {
        try {
            // ดึงข้อมูลจาก API ของคุณ
            const response = await axios.get('/api/v1/researchservice'); 
            
            // ตรวจสอบว่าข้อมูลที่ได้มาเป็น Array หรือไม่
            if (response.data) {
                const formattedOptions = response.data.map(item => ({
                    // ตรวจสอบชื่อ property ให้ตรงกับที่ API ส่งมา (value กับ label)
                    value: item.value, 
                    label: item.label
                }));
                setResearchServiceList(formattedOptions);
            }
        } catch (error) {
            console.error("Error fetching research services:", error);
        }
    };

    fetchData();

  }, []);

    useEffect(() => {
        if (tempServiceKey && researchServiceList.length > 0) {
                const selected = researchServiceList.find(
                item => String(item.value) === String(tempServiceKey)
            );
                if (selected) {
                setResearchService(selected);
            }
        }
    }, [tempServiceKey, researchServiceList]);

  const handleViewOrDownloadFile = async (fileKey, fileName, isDownload = false) => {
  try {
    // เรียก API โดยระบุ responseType เป็น 'blob' เพื่อรองรับไฟล์ Binary
    const response = await axios.get(
      `/api/v1/service-request/file/${fileKey}?download=${isDownload}`,
      { responseType: 'blob' }
    );

    // สร้าง Blob URL สำหรับ Preview/Download
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const fileURL = window.URL.createObjectURL(blob);

    if (isDownload) {
      // เทคนิคการสร้างแท็ก <a> เพื่อสั่ง Download ไฟล์ลงเครื่อง
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      // เปิดไฟล์ดูบน Tab ใหม่ใน Browser (Inline)
      window.open(fileURL, '_blank');
    }

    // ล้าง Memory
    setTimeout(() => window.URL.revokeObjectURL(fileURL), 10000);
  } catch (error) {
    console.error("Error downloading file:", error);
    alert("ไม่สามารถดึงไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
  }
};

 
  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if(researchService === null)
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรายการขอใช้บริการ"}</li>);
    }
      

    if(otherDetails === '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรายละเอียดการขอใช้บริการ"}</li>);
    }

    if(researchTitle === '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"ชื่อโครงการวิจัย/บทความวิจัย"}</li>);
    }

    if(researchObjective === '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวัตถุประสงค์การวิจัย"}</li>);
    }

    if(researchMethodology === '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"รูปแบบการวิจัย"}</li>);
    }



    
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  const handleCancel = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    
    axios.put('/api/v1/service-request/cancel/' + location.state.ServiceRequestID, null)
          .then(
              result => {
 
                  if (result.data.result == 200) {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setModal2(true)
                  }
                  else {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setErrMsg(result.data.msg)
                      setModalError(true)
                  }

              },
              error => { console.log(error); }
    );  
    
  };
  

  const handleConfirm = async (evt) => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


      const _approve = [];

  

       var research = {
            otherServiceText : additionalInfo,
            requestDetail : otherDetails,
            projectTitle : researchTitle,
            researchObjective : researchObjective,
            populationSample : populationAndSample,
            additionalNote : otherInfo,
            researchServiceKey : researchService?.value ?? null,
            researchDesign : researchMethodology,
            serviceApprove: _approve
       };

       // 1. สร้าง FormData
      const formData = new FormData();
  
      // แปลง Object ข้อมูลหลักเป็น JSON string ใส่เข้าไปใน FormData
      formData.append("data", JSON.stringify(research));

    // 2 ดึงไฟล์ทั้งหมดจาก State 'selectedFiles' วนลูปยัดลง FormData
  if (selectedFiles && selectedFiles.length > 0) {
    selectedFiles.forEach((file) => {
      // Key ชื่อ "files" ต้องตรงกับ DTO ฝั่ง C# Backend (List<IFormFile> Files)
      formData.append("files", file); 
    });
  }

      // กำหนด Header สำหรับ Multipart Form Data
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      };

      try {
    let result;
    // แก้ไข
    if (location.state?.ServiceRequestID) {
      result = await axios.put(`/api/v1/service-request/${location.state.ServiceRequestID}`, formData, config);
    } 
    // สร้างใหม่
    else {
      result = await axios.post('/api/v1/service-request', formData, config);
    }

    if (result.data.result === 200) {
      if (result.data.data?.serviceRequestID) {
        setServiceRequestID(result.data.data.serviceRequestID);
      }
      setIcon("far fa-question-circle");
      setModal(false);
      setModal2(true);
    } else {
      setIcon("far fa-question-circle");
      setModal(false);
      setErrMsg(result.data.msg);
      setModalError(true);
    }
  } catch (error) {
    console.error(error);
    setIcon("far fa-question-circle");
    setModal(false);
    setErrMsg("System Error");
    setModalError(true);
  }

      
      // //แก้ไข
      // if(location.state != null && location.state.ServiceRequestID != null && location.state.ServiceRequestID != '')
      // {

      //   // (url,body)
      //   axios.put('/api/v1/service-request/' + location.state.ServiceRequestID, research)
      //   .then(
      //     result => {
            
      //        if(result.data.result == 200)
      //       {
      //         setIcon("far fa-question-circle"); 
      //         setModal(false) 
      //         setModal2(true)
      //       }
      //       else
      //       {
      //         setIcon("far fa-question-circle"); 
      //         setModal(false) 
      //         setErrMsg(result.data.msg)
      //         setModalError(true) 
      //       }
  
      //     },
      //     error => {console.log(error);}
      //   );  
      // }
      // else{
      //   //ลงทะเบียนใหม่

      //   axios.post('/api/v1/service-request', research)
      //   .then(
      //     result => {  
      //       if(result.data.result == 200)
      //       {
      //         setServiceRequestID(result.data.data.serviceRequestID)
      //         setIcon("far fa-question-circle"); 
      //         setModal(false) 
      //         setModal2(true)
      //       }
      //       else
      //       {
      //         setIcon("far fa-question-circle"); 
      //         setModal(false) 
      //         setErrMsg(result.data.msg)
      //         setModalError(true) 
      //       }

      //     },
      //     error => {console.log(error);}
      //   );  

      // }
      
  };


  const GotoEdit = evt => {
    evt.preventDefault();
    setModal2(false);

    const targetId = (location.state != null && location.state.ServiceRequestID != null && location.state.ServiceRequestID != '')
        ? location.state.ServiceRequestID
        : ServiceRequestID;

    if (targetId) {
        axios.get("/api/v1/service-request/" + targetId)
            .then(resEdit => {
                var res = resEdit.data.data;
                if (res) {
                    setServiceApprove(res.serviceApprove || []);
                    setExistingFiles(resEdit.data.files || []);
                }
            })
            .catch(err => console.log(err));

        props.history.push({ pathname: '/data-analysis/id/' + targetId });
    }

};


    const fetchHoliday = (yearMonth) => {
      axios.get('/api/holiday/' + yearMonth)
      .then(
        result => {
              setHolidays(result.data.data)


          }, error => { console.log(error); }
      );  

  };


  const handleApprove = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const formData = new FormData();
    formData.append("isApprove", "true");
    if (ApproveDescription) {
        formData.append("approveDescription", ApproveDescription);
    }
    if (approveFiles && approveFiles.length > 0) {
        approveFiles.forEach((file) => {
            formData.append("files", file);
        });
    }

    const config = {
        headers: { 'Content-Type': 'multipart/form-data' }
    };
        
    axios.put('/api/v1/service-request/approve/' + ServiceApproveKey, formData, config)
              .then(
                  result => {

                      if (result.data.result == 200) {
                          setIcon("far fa-question-circle");
                          setModalApprove(false);
                          setApproveFiles([]);
                          setModal2(true);
                      }
                      else {
                          setIcon("far fa-question-circle");
                          setModalApprove(false);
                          setErrMsg(result.data.msg);
                          setModalError(true);
                      }

                  },
                  error => { console.log(error); }
        );
        
    }


    //function renderFlowLevel(approve, index) {
const renderFlowLevel = (approve, index) => {
    
    var hrDT = (moment(approve.approveDT).isValid()) ? moment(approve.approveDT).format("D MMM BB HH:mm") : '';

    var flowTxt = '';
    var tmpColor = '';

    if (approve.approveStatusKey == 1 && approve.approveTypeKey == 4)
    {
      flowTxt = 'รอเตรียมข้อมูล' ;
      tmpColor = '#ff9800';
    }
    else if (approve.approveStatusKey == 2 && approve.approveTypeKey == 4)
    {
      flowTxt = 'เตรียมข้อมูลแล้ว' ;
      tmpColor = '#4caf50';
    }
    else if (approve.approveStatusKey == 1 && approve.approveTypeKey == 3)
    {
      flowTxt = 'รอวิเคราะห์ข้อมูล' ;
      tmpColor = '#ff9800';
    }
    else if (approve.approveStatusKey == 2 && approve.approveTypeKey == 3)
    {
      flowTxt = 'วิเคราะห์ข้อมูลแล้ว' ;
      tmpColor = '#4caf50';
    }
    else if (approve.approveStatusKey == 1 && approve.approveTypeKey == 2)
    {
      flowTxt = 'รอส่งผลการวิเคราะห์ให้ผู้วิจัย' ;
      tmpColor = '#ff9800';
    }
    else if (approve.approveStatusKey == 2 && approve.approveTypeKey == 2)
    {
      flowTxt = 'ส่งผลการวิเคราะห์ให้ผู้วิจัยแล้ว' ;
      tmpColor = '#4caf50';
    }
     else if (approve.approveStatusKey == 1 && approve.approveTypeKey == 1)
    {
      flowTxt = 'รออธิบายผลการวิเคราะห์ข้อมูล' ;
      tmpColor = '#ff9800';
    }
    else if (approve.approveStatusKey == 2 && approve.approveTypeKey == 1)
    {
      flowTxt = 'อธิบายผลการวิเคราะห์ข้อมูลแล้ว' ;
      tmpColor = '#4caf50';
    }
    else if (approve.approveStatusKey == -1)
    {
    //   flowTxt = (flow != null) ? flow.flowName+flow.flowRejectName : '';
    //   tmpColor = '#f44336';
    }
    else{

    }

    const getApproveBtnText = (typeKey) => {
        switch (typeKey) {
            case 4:
                return "เตรียมข้อมูล";
            case 3:
                return "วิเคราะห์ข้อมูล";
            case 2:
                return "ส่งผลการวิเคราะห์ให้ผู้วิจัย";
            case 1:
                return "อธิบายผลการวิเคราะห์ข้อมูล";
            default:
                return "ดำเนินการ";
        }
    };
    
    const stepFiles = existingFiles.filter(f => f.approveTypeKey === approve.approveTypeKey);
    
    return <div key={index}>
                <Hidden xsDown key={"HR01"}>
                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography style={{ color: tmpColor, fontWeight: 'bold' }}>{flowTxt}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                {hrDT}
                            </Typography>
                            {stepFiles && stepFiles.length > 0 && (
                                <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
                                    {stepFiles.map((file) => (
                                        <div
                                            key={file.fileKey}
                                            style={{
                                                padding: '6px 10px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '6px',
                                                border: '1px solid #dee2e6',
                                                textAlign: 'right',
                                                maxWidth: '260px',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px', marginBottom: '2px' }}>
                                                <span style={{ fontWeight: '600', fontSize: '0.85em', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '210px' }} title={file.fileName}>
                                                    {file.fileName}
                                                </span>
                                                <i className="fa fa-file" style={{ color: '#0d6efd', fontSize: '0.9em' }}></i>
                                            </div>
                                            <div style={{ fontSize: '0.75em', color: '#6c757d', marginBottom: '4px' }}>
                                                {(file.fileSize / 1024 / 1024).toFixed(2)} MB
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '6px' }}>
                                                <Button
                                                    size="sm"
                                                    color="info"
                                                    outline
                                                    style={{ padding: '2px 8px', fontSize: '0.75rem', lineHeight: '1.2' }}
                                                    onClick={() => handleViewOrDownloadFile(file.fileKey, file.fileName, false)}
                                                >
                                                    <i className="fa fa-eye" style={{ marginRight: '3px' }}></i> เปิดดู
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    color="primary"
                                                    style={{ padding: '2px 8px', fontSize: '0.75rem', lineHeight: '1.2' }}
                                                    onClick={() => handleViewOrDownloadFile(file.fileKey, file.fileName, true)}
                                                >
                                                    <i className="fa fa-download" style={{ marginRight: '3px' }}></i> ดาวน์โหลด
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </TimelineOppositeContent>
                        <TimelineSeparator style={{ minHeight: '120px' }}>
                            <TimelineDot color="primary" variant="outlined">
                                <Avatar alt={"duangdao"} src={"https://e.trangskin.go.th/avatar/duangdao.jpg"} className={classes.largeAvatar} />
                            </TimelineDot>

                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper}>
                                {(approve.userView != null) ?
                                    <>
                                        <Typography>{approve.approveDescription}</Typography>
                                        <Typography>{approve.userView.firstName} {approve.userView.lastName} </Typography>
                                    </> : <></>
                                }
                                {
                                    (approve.approveStatusKey == 1 && (currentUser.userName == 'duangdao' || isHR)) ?
                                        <Button
                                                    variant="contained"
                                                    color="info"
                                                    startIcon={<i className={"fa fa-thumbs-up"}></i>}
                                                    onClick={e => {
                                                        setModalApprove(true);
                                                        setServiceApproveKey(approve.serviceApproveKey);
                                                        setApproveTypeKey(approve.approveTypeKey);
                                                    }
                                                }
                                        >
                                            {getApproveBtnText(approve.approveTypeKey)}
                                        </Button> : <></>
                                }
                            </Paper>
                        </TimelineContent>
                    </TimelineItem>
                </Hidden>
            </div>
        }




    const classes = useStyles();

    return (

        <div>
            <Grid>

                <Col xs={12} sm={12} md={12}>
                {/* <Card style={{display: ((isEdit && !isHR && currentUser.userName != UserName) ? 'none' : '')}}> */}
                <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>แบบฟอร์มขอใช้บริการวิเคราะห์ข้อมูลงานวิจัย</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>

                        </CardHeader>

                        <CardBody>
                             <Grid style={{ display: ((isCancel) ? '' : 'none') }}>
                                <Col xs={12} sm={12} md={12} style={{ background: 'red' }} >
                                    
                                    <h4 style={{color:'white', fontSize:'24px', textAlign:'center'}}>ยกเลิกการขอแล้ว</h4>
                                   
                                </Col>
                            </Grid>
                            <Grid>
                            <Col xs={12} sm={12} md={12}>
                                <h3 style={{ marginBottom: '20px', color: '#333' }}>การขอใช้บริการ</h3>
                            </Col>
                                <Col xs={12} sm={6} md={6}>
                                   <TSSelect2 
                                        label="รายการขอใช้บริการ" 
                                        options={researchServiceList} 
                                        value={researchService?.value} // ส่งเฉพาะ "ตัวเลข" ID เข้าไป
                                        onChange={e => setResearchService(e)} 
                                    />
                                </Col>
                                {researchService?.value === 6 && (
                                    <Col xs={12} sm={6} md={6}>
                                        <Label>ระบุ</Label>
                                        <Input 
                                            type="textarea" 
                                            value={additionalInfo} 
                                            onChange={e => setAdditionalInfo(e.target.value)} 
                                        />
                                    </Col>
                                )}
                                <Col xs={12} sm={12} md={12}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="otherDetails">รายละเอียดการขอใช้บริการ (หากต้องมีการดูข้อมูล/คุยรายละเอียดต่าง ๆ โปรดระบุวันและเวลา)</Label>  
                                      <Input
                                          id="otherDetails"
                                          cols="80"
                                          name="otherDetails"
                                          placeholder="รายละเอียดการขอใช้บริการ"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={otherDetails}
                                          onChange={e => setOtherDetails(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                            </Grid>

                            <div style={{ 
                                height: '2px', 
                                backgroundColor: '#f0f0f0', 
                                margin: '40px 0', 
                                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)' 
                            }} />
                            <h3 style={{ marginBottom: '20px', color: '#333' }}>ข้อมูลเพิ่มเติม</h3>
               
                            <Grid>
                              <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">ชื่อโครงการวิจัย/บทความวิจัย </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="researchTitle"
                                          cols="80"
                                          name="researchTitle"
                                          placeholder="ชื่อโครงการวิจัย/บทความวิจัย"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={researchTitle}
                                          onChange={e => setResearchTitle(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                              <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">วัตถุประสงค์การวิจัย </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="researchObjective"
                                          cols="80"
                                          name="researchObjective"
                                          placeholder="วัตถุประสงค์การวิจัย"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={researchObjective}
                                          onChange={e => setResearchObjective(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>  
                              <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">รูปแบบการวิจัย </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="researchMethodology"
                                          cols="80"
                                          name="researchMethodology"
                                          placeholder="รูปแบบการวิจัย"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={researchMethodology}
                                          onChange={e => setResearchMethodology(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>  
                              <Col xs={12} sm={12} md={6}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">ประชากรและกลุ่มตัวอย่าง </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="populationAndSample"
                                          cols="80"
                                          name="populationAndSample"
                                          placeholder="ประชากรและกลุ่มตัวอย่าง"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={populationAndSample}
                                          onChange={e => setPopulationAndSample(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>  
                              <Col xs={12} sm={12} md={12}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">รายละเอียดอื่นๆ ที่เกี่ยวข้อง </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="otherInfo"
                                          cols="80"
                                          name="otherInfo"
                                          placeholder="รายละเอียดอื่นๆ ที่เกี่ยวข้อง"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={otherInfo}
                                          onChange={e => setOtherInfo(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>  
                             
                            </Grid>

                            <Grid><Col>&nbsp;</Col></Grid>

          <h5 style={{ fontWeight: 'bold', marginBottom: '8px' }}>แนบไฟล์ (ถ้ามี)</h5>
<p style={{ color: '#6c757d', fontSize: '0.9em', marginBottom: '15px' }}>
    Upload supported files. Max 10 MB per file.
</p>

{/* ใส่ property "multiple" เพิ่มเข้าไปที่นี่ */}
<input
    type="file"
    multiple
    ref={fileInputRef}
    style={{ display: 'none' }}
    onChange={handleFileChange}
/>

{/* ปุ่ม Add files แสดงอยู่ตลอดเวลาเพื่อให้ผู้ใช้กดเลือกไฟล์เพิ่มสลับกันได้เรื่อย ๆ */}
<Button
    color="light"
    onClick={() => fileInputRef.current.click()}
    style={{
        display: 'inline-flex',
        alignItems: 'center',
        border: '1px solid #dee2e6',
        backgroundColor: '#fff',
        padding: '8px 16px',
        borderRadius: '5px',
        color: '#0d6efd',
        fontWeight: '500',
        width: 'fit-content',
        marginBottom: '15px' // เพิ่มระยะห่างด้านล่าง
    }}
>
    <span style={{ marginRight: '8px' }}>+</span> Add files
</Button>

{/* ลูปแสดงผลรายชื่อไฟล์ทั้งหมดที่เลือกในคิว */}
<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
    {selectedFiles.map((file, index) => (
        <div key={index} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            padding: '10px 15px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '8px',
            border: '1px dashed #ced4da'
        }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa fa-file" style={{ marginRight: '10px', color: '#6c757d' }}></i>
                <div>
                    <div style={{ fontWeight: '500', fontSize: '0.95em' }}>{file.name}</div>
                    <div style={{ fontSize: '0.8em', color: '#6c757d' }}>
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                    </div>
                </div>
            </div>
            <Button 
                close 
                onClick={() => removeFile(index)} // ส่ง index ไปเพื่อลบให้ถูกไฟล์
                style={{ fontSize: '1.2rem', color: 'red', border: 'none', background: 'none' }}
            >
                ×
            </Button>
        </div>
    ))}
</div>

<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
      <h5 style={{ fontWeight: 'bold' }}>ไฟล์แนบในระบบ</h5>
      {existingFiles.map((file) => (
        <div
          key={file.fileKey}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 15px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #dee2e6'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <i className="fa fa-file" style={{ marginRight: '10px', color: '#0d6efd', fontSize: '1.2rem' }}></i>
            <div>
              <div style={{ fontWeight: '500', fontSize: '0.95em' }}>{file.fileName}</div>
              <div style={{ fontSize: '0.8em', color: '#6c757d' }}>
                {(file.fileSize / 1024 / 1024).toFixed(2)} MB
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            {/* ปุ่มเปิดดูไฟล์ออนไลน์ (Inline) */}
            <Button
              size="sm"
              color="info"
              outline
              onClick={() => handleViewOrDownloadFile(file.fileKey, file.fileName, false)}
            >
              <i className="fa fa-eye" style={{ marginRight: '5px' }}></i> เปิดดู
            </Button>

            {/* ปุ่มดาวน์โหลดไฟล์ลงเครื่อง (Attachment) */}
            <Button
              size="sm"
              color="primary"
              onClick={() => handleViewOrDownloadFile(file.fileKey, file.fileName, true)}
            >
              <i className="fa fa-download" style={{ marginRight: '5px' }}></i> ดาวน์โหลด
            </Button>
          </div>
        </div>
      ))}
    </div>

                            <Grid><Col>&nbsp;</Col></Grid>
                           {(!isCancel) ? 
                            <Grid style={{ display: ((!isCancel && !isEdit && currentUser.userName != UserName) || (isEdit && currentUser.userName == UserName && LeaveApprove.length > 0 ? LeaveApprove[0].isApprove == null : false) || (isHR && !ApproveDirector) || (currentUser.userName == 'madarakung') ? '' : 'none') }}>
                            
                                {(location.state != null && location.state != '' && location.state.ServiceRequestID != null && location.state.ServiceRequestID != '') ? 
                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                    <Button color="warning" onClick={handleSubmit} fullWidth>
                                      <i className={"fa fa-edit"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                      <h4>แก้ไข</h4>
                                    </Button>
                                </Col>
                                :
                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                        <Button color="info" onClick={handleSubmit /*handleConfirmTest*/} fullWidth>
                                    <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                    <h4>บันทึก</h4>
                                  </Button>
                                </Col>
                                }
                                
                                <Col xs={12} sm={12} md={2} >
                                  <>&nbsp;</>             
                                </Col>

                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                    <Button color="danger" onClick={() => { setModalCancel(true); }} fullWidth>
                                              <h4>ยกเลิกการขอ</h4>
                                  </Button>
                                </Col>
                            </Grid>
                          :  <Grid></Grid>}

                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                          {/* Confirm */}
                          <Modal toggle={() => {setModal(false); setIcon("far fa-question-circle");}} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการบันทึกข้อมูล"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                            <Button
                                color="info"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>

                              <Button
                                color="danger"
                                type="button"
                                onClick={() => {setModal(false); setIcon("far fa-question-circle");}}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>
 
                            </div>
                          </Modal>
                            {/* Approve */}
                            <Modal toggle={() => { setModalApprove(false); setIcon("far fa-question-circle"); setApproveFiles([]); }} isOpen={modalApprove}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i> {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการดำเนินงาน"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </div>
                              
                                </div>
                                <ModalBody>
                                    <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                        <h4 style={{ fontWeight: 'bold', margin: 0, color: '#333' }}>
                                            {ApproveTypeKey === 4 && "ยืนยันการเตรียมข้อมูล"}
                                            {ApproveTypeKey === 3 && "ยืนยันการวิเคราะห์ข้อมูล"}
                                            {ApproveTypeKey === 2 && "ยืนยันการส่งผลการวิเคราะห์ให้ผู้วิจัย"}
                                            {ApproveTypeKey === 1 && "ยืนยันการอธิบายผลการวิเคราะห์ข้อมูล"}
                                        </h4>
                                    </div>

                                    {ApproveTypeKey === 3 && (
                                        <div style={{ borderTop: '1px solid #dee2e6', paddingTop: '15px', marginTop: '10px' }}>
                                            <p style={{ fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                                                ต้องการแนบไฟล์ผลการวิเคราะห์ข้อมูลหรือไม่? (ถ้ามี)
                                            </p>
                                            <p style={{ color: '#6c757d', fontSize: '0.85em', marginBottom: '12px' }}>
                                                อัปโหลดไฟล์ที่รองรับ เช่น เอกสาร, สถิติ, ตาราง หรือรูปภาพ ขนาดไม่เกิน 10 MB ต่อไฟล์ (หากไม่มีไฟล์ สามารถกดยืนยันเพื่อผ่านขั้นตอนนี้ได้ทันที)
                                            </p>

                                            <input
                                                type="file"
                                                multiple
                                                ref={approveFileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={handleApproveFileChange}
                                            />

                                            <Button
                                                color="light"
                                                onClick={() => approveFileInputRef.current && approveFileInputRef.current.click()}
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    border: '1px solid #dee2e6',
                                                    backgroundColor: '#fff',
                                                    padding: '6px 14px',
                                                    borderRadius: '5px',
                                                    color: '#0d6efd',
                                                    fontWeight: '500',
                                                    fontSize: '0.9em',
                                                    marginBottom: '12px'
                                                }}
                                            >
                                                <span style={{ marginRight: '6px', fontSize: '1.2em' }}>+</span> แนบไฟล์ (Add files)
                                            </Button>

                                            {approveFiles.length > 0 && (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '180px', overflowY: 'auto' }}>
                                                    {approveFiles.map((file, idx) => (
                                                        <div key={idx} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '8px 12px',
                                                            backgroundColor: '#f8f9fa',
                                                            borderRadius: '6px',
                                                            border: '1px dashed #ced4da'
                                                        }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                                                <i className="fa fa-file" style={{ marginRight: '8px', color: '#6c757d' }}></i>
                                                                <div>
                                                                    <div style={{ fontWeight: '500', fontSize: '0.88em', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '280px', overflow: 'hidden' }}>
                                                                        {file.name}
                                                                    </div>
                                                                    <div style={{ fontSize: '0.75em', color: '#6c757d' }}>
                                                                        {(file.size / 1024 / 1024).toFixed(2)} MB
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Button
                                                                close
                                                                onClick={() => removeApproveFile(idx)}
                                                                style={{ fontSize: '1.1rem', color: 'red', border: 'none', background: 'none' }}
                                                            >
                                                                ×
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={handleApprove}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setModalApprove(false); setIcon("far fa-question-circle"); setApproveFiles([]); }}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                </div>
                            </Modal>

                          
                          {/* Success */}
                         <Modal toggle={GotoEdit} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ
                              

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={GotoEdit}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>           


                            {/* Cancel */}
                            <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันยกเลิกการขอ"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleCancel}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ปฏิเสธ</h4>
                                    </Button>


                                </div>
                            </Modal>


                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                                <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                <ul className="text-danger">
                                    {errMsg}
                                </ul>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>
                      </CardFooter>
                  </Card>


                <Card style={{display: ((isEdit && !isCancel) ? '' : 'none')}}>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>ติดตามสถานะ การวิเคราะห์ข้อมูล</h4>
                            <p className={classes.cardCategoryWhite}> </p>

                        </CardHeader>

                        <CardBody>
                            
                            <Grid>
                                <Col xs={12} sm={12} md={12} key={1} >
                                  <Timeline align="alternate">                                 
                                    {
                                        ServiceApprove.map((item, index) => (
                                        renderFlowLevel(item, index)
                                    ))}

                                  </Timeline>
                                </Col>
                            </Grid>
                        </CardBody>
                  </Card>
                 
              </Col>
            </Grid>
        </div>
    );
}
export default Request;